var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.74819 5.52513L3.16219 0.939127C2.88079 0.657865 2.49919 0.499907 2.10134 0.5C1.70348 0.500094 1.32195 0.658232 1.04069 0.939627C0.759427 1.22102 0.601469 1.60262 0.601562 2.00048C0.601656 2.39834 0.759795 2.77986 1.04119 3.06113L5.62719 7.64613C5.67375 7.69257 5.71069 7.74775 5.7359 7.80849C5.76111 7.86924 5.77408 7.93436 5.77408 8.00013C5.77408 8.0659 5.76111 8.13102 5.7359 8.19176C5.71069 8.25251 5.67375 8.30768 5.62719 8.35413L1.04119 12.9391C0.759793 13.2204 0.601654 13.6019 0.60156 13.9998C0.601466 14.3976 0.759425 14.7792 1.04069 15.0606C1.32195 15.342 1.70348 15.5002 2.10133 15.5003C2.49919 15.5003 2.88079 15.3424 3.16219 15.0611L7.74819 10.4751C8.40342 9.81809 8.77137 8.92804 8.77137 8.00013C8.77137 7.07221 8.40342 6.18216 7.74819 5.52513Z",
    fill: "#112348"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.d89b0169ffbcf6e0dfdaa44bc3dedc82.svg";
export { ForwardRef as ReactComponent };